import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { appStore } from '@/store'
// 国际化插件
import { useI18n } from '@/lang/index'
import { setupDirectives } from '@/utils/directives'
// 按钮点击特效
import { initCursorEffect } from '@/utils'
// 引入样式
import '@/style/index.scss'
import '@icon-park/vue-next/styles/index.css'
import '@/utils/rem'
import resourceUrl from '@/config/resource'
// 充值弹窗
import { useDialog } from '@/utils/dialogUtils'

const app = createApp(App)

// 添加全局错误处理器
app.config.errorHandler = (err, instance, info) => {
  console.error('全局错误捕获:', err)
  console.info('错误来源组件:', instance)
  console.info('错误信息:', info)
}

app.use(resourceUrl)
// 使用国际化
useI18n(app)
// 使用 vue-router
app.use(router)
// 使用 pinia store
app.use(appStore)
// 使用指令
setupDirectives(app)
// 注册为全局属性
app.config.globalProperties.$dialog = useDialog()

app.mount('#app')

initCursorEffect()
